import { Logic } from '~common/ui-logic/logic'
import type { AppContextType } from '~/app-context'
import type { UserBankAccount } from '~/storage/types'

export interface ManageBankAccountsLogicDependencies {}

export interface ManageBankAccountsLogicState {
    // Empty or add future state if needed
}

export class ManageBankAccountsLogic extends Logic<
    ManageBankAccountsLogicDependencies & AppContextType,
    ManageBankAccountsLogicState
> {
    getInitialState = (): ManageBankAccountsLogicState => ({})

    addBankAccount() {
        this.deps.globalEvents?.emit({
            type: 'openModal',
            modalType: 'transactions-upload',
        })
    }

    selectAccount(account: UserBankAccount) {
        this.deps.globalEvents?.emit({
            type: 'filterTransactionsByAccountIban',
            iban: account.iban,
        })
        this.deps.services.cache.setKey('selectedAccountIban', account.iban)
    }
}
